<template lang="pug">
  .container
    .content-processos
      .processos-main
        el-card.card-container(shadow="hover")
          b Solicitar abertura de processo físico:
          .dados-processo
            validation-observer.align(ref='validation' tag='form')
              el-col(:span="8" style="flex: 1")
                    validation-provider(rules="required", v-slot="{ errors }", name="Tipo de cadastro")
                      app-label(label="Selecione o tipo de processo:")
                      el-select(
                        clearable,
                        filterable,
                        default-first-option=false,
                        name="tipo cadastro",
                        collapse-tags,
                        v-model="tipoCadastro",
                      )
                        el-option(
                          v-for="item in tiposCadastros",
                          :key="item.key",
                          :label="item.name",
                          :value="item.value",
                        )
                      span.help.erro {{ errors[0] }}
              el-col(:span="8" style="flex: 1")
                  validation-provider(rules='required', ref="provider", v-slot="{ errors }", name="Número Processo")
                    div(style="display: flex")
                      app-label(label="Insira o número do processo:" required='required')
                    el-input.input(
                      v-model="numeroProcesso"
                      name="Número Processo"
                      :class="{'erro' : errors.length}"
                      @input="validateInput"
                    )
                    span.help.erro {{ errors[0] }}
          app-buttons-cadastro.alinhar(
            :showButtonProximo="true"
            :isPrimeiroPasso="true"
            @cancelar="cancelar()"
            @proximo="proximo()"
          )
  </template>

<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions, mapGetters } from 'vuex'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import empty from '../cadastros/maranhao/empty/emptyProcessoFisico'
import { cloneDeep } from 'lodash'
import AppLabel from '@/components/AppLabel'

export default {

  mixins: [
    AppNotificacao
  ],

  components: {
    AppButtonsCadastro,
    AppLabel
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    observer: {
      type: Object
    }
  },
  data () {
    return {
      numeroProcesso: '',
      cadastro: cloneDeep(empty),
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      tiposCadastros: [
        {
          key: 1,
          value: 'NAO_ONEROSO_FISICO',
          name: 'Não oneroso'
        },
        {
          key: 2,
          value: 'ONEROSO_FISICO',
          name: 'Oneroso'
        }
      ],
      tipoCadastro: ''
    }
  },
  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      salvarCadastro: 'cadastro/salvarCadastro',
      finalizarCadastro: 'cadastro/finalizarCadastro',
      existeProcesso: 'processo/existeProcesso'
    }),
    async isProcessoExiste () {
      let data = await this.existeProcesso(this.numeroProcesso)
      if (data) {
        this.$refs.provider.applyResult({
          errors: ['Já existe processo com esse número'],
          valid: true,
          failedRules: {}
        })
        return true
      }
      return false
    },
    cancelar () {
      this.$router.push({
        name: this.$route.path.split('/')[1] + '/processo-fisico',
        params: {},
        props: {
          isLiberacao: true
        }
      })
    },

    formataRots () {
      return this.$route.path.includes('central') ? '' : this.$route.path.split('/')[1] + '/'
    },

    async validarCampos () {
      return this.$refs.validation.validate()
    },

    async proximo () {
      const validado = await this.validarCampos()
      if (!validado) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
        return
      }
      if (await this.isProcessoExiste()) {
        return
      }
      try {
        this.cadastro.usuario.id = this.usuario.id
        this.cadastro.json.numeroProcesso = this.numeroProcesso
        this.cadastro.json.interessado.pessoa.tipo = 'PF'
        this.cadastro.json = JSON.stringify(this.cadastro.json)
        const response = await this.salvarCadastro(this.cadastro)
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.DADOS_SALVOS_SUCESSO
        )
        await this.$router.push({
          name: this.formataRots() + 'processo-fisico/cadastrante',
          params: {
            idCadastro: response.id
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    validateInput (event) {
      this.numeroProcesso = this.numeroProcesso.replace(/[^\d/.]/g, '')

      if (this.numeroProcesso && this.numeroProcesso.length > 45) {
        this.numeroProcesso = this.numeroProcesso.slice(0, 45)
      }
    }
  },

  watch: {
    tipoCadastro (val) {
      this.cadastro.tipo['codigo'] = val
      this.cadastro.json.tipo = val
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-processos {
    flex: 1;
    padding: 20px;
  }

  .processos-main {
    padding: 10px 0;
    height: 81vh;
  }

  .dados-processo {
    display: flex;
    flex-direction: column;
    gap: 3vh;
    margin-top: 1%;
  }

  .alinhar {
    display: flex;
    justify-content: center;
  }

  #numero-processo {
    display: flex;

    #title {
      width: 15%;
      display: flex;
      text-align: center;
      align-items: center;
    }

    .el-input {
      width: fit-content;
    }
  }

  .align {
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 7%;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/processoFisico/EscolhaTipoProcessoFisico.vue